import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import {getRequest} from "../routes/Routes";
import Expand from 'react-expand-animated';
import '../assets/css/Home.css';
import {getUser} from "../auth/Auth";
import Loading from "../components/Loading";

class ManagePartners extends Component {
    constructor(props) {
        super(props);
        this.state = {partners: [], user: null, loading: true};
    }

    componentDidMount() {
        getUser(this.props.history).then(data => {
            this.setState({user: data});
            this.loadPartners();
        });
    }

    render() {
        if (this.state.user) {
            return (
                this.state.loading ?
                    <Loading/>
                    : <div className="container category-list partner-list">
                        <h1 className="heading">Partners</h1>
                        <hr/>
                        {this.getPartnerBody()}
                    </div>
            );
        } else {
            return null;
        }
    }

    getPartnerBody = () => {
        let partnerBody = [];
        this.state.partners.forEach((partner, index) => {
            partnerBody.push(
                <div key={index}>
                    <div className="d-flex bd-highlight w-100 order order-container"
                         onClick={() => this.expandPartner(index)}>
                        <div className="p-2 flex-fill bd-highlight">
                            <h4>{partner.name}</h4>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Email: <strong>{partner.email}</strong></div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Phone: <strong>{partner.phone}</strong></div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Address: <strong>{partner.address + ", " + partner.city}</strong></div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Commission: <strong>{partner.commission}</strong></div>
                        </div>
                    </div>
                    <Expand open={partner.open}>
                        <div className="order-container">
                            User: <strong>{partner.user.first_name + " " + partner.user.last_name}</strong><br/>
                            User Email: <strong>{partner.user.email}</strong><br/>
                            User Address: <strong>{partner.user.address + ", " + partner.user.city}</strong><br/>
                            User Phone: <strong>{partner.phone}</strong><br/>
                        </div>
                        <table className="account-details">
                            <thead>
                            <tr>
                                <th>Product Name</th>
                                <th>Description</th>
                                <th>Part Number</th>
                                <th>Category</th>
                                <th>Price</th>
                                <th>Stock</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.getPartnerProductBody(partner.products)}
                            </tbody>
                        </table>
                    </Expand>
                </div>
            )
        });
        return partnerBody;
    };

    getPartnerProductBody = (products) => {
        let productBody = [];
        products.forEach((product, index) => {
            productBody.push(
                <tr key={index}>
                    <td>{product.name}</td>
                    <td>{product.description}</td>
                    <td>{product.part_number}</td>
                    <td>{product.category.name}</td>
                    <td>{product.price}</td>
                    <td>{product.stock}</td>
                </tr>
            )
        });
        return productBody;
    }

    loadPartners = () => {
        let {partners} = this.state;
        getRequest('/api/partners').then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    response.data.partners.forEach((partner) => {
                        partner.open = false;
                        partners.push(partner);
                    });
                    this.setState({partners: partners, loading: false});
                }
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    };

    expandPartner = (index) => {
        let {partners} = this.state;
        partners[index].open = !partners[index].open;
        this.setState({partners: partners});
    };
}

export default withAlert()(withRouter(ManagePartners));